const FEATURES = [
  {
    icon: 'ri-compass-3-line',
    title: '全网聚合导航',
    desc: '一站式收录韩漫之家、韩漫屋、韩漫网、韩漫吧等主流韩漫漫画网站入口，覆盖免费韩漫网址和付费平台，让您无需逐个搜索，韩漫在线观看触手可及。',
  },
  {
    icon: 'ri-stack-line',
    title: '多维分类索引',
    desc: '按恋爱、奇幻、热血、悬疑、都市、校园等题材精细分类，同时提供人气榜单、更新动态、专题合集等多维度韩漫网址导航，快速定位心仪内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠更新',
    desc: '所有收录的韩漫网站均经过人工审核验证，确保链接有效性与内容安全性。每日跟踪韩漫平台更新动态，韩漫导航信息保持最新状态。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为什么选择韩漫导航作为您的韩漫入口
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {FEATURES.map((feature, i) => (
            <div key={i} className="text-center group">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}